import { type RichContent, RichContentType } from '@openx/components-core/lib/AiChat/types.ts';
import { AudienceResultsCard } from './AudienceResultsCard.tsx';
import { InventoryResultsCard } from './InventoryResultsCard.tsx';

type RichContentCardProps = {
  content: RichContent;
  disabled: boolean;
};

export const RichContentCard = ({ content, disabled }: RichContentCardProps) => {
  const commonProps = { disabled };

  if (content.type === RichContentType.AUDIENCE_RESULTS) {
    return <AudienceResultsCard {...commonProps} matches={content.matches} stats={content.stats} />;
  }

  if (content.type === RichContentType.INVENTORY_RESULTS) {
    return <InventoryResultsCard {...commonProps} matches={content.matches} stats={content.stats} />;
  }

  return null;
};
